// import {
//   Box,
//   Button,
//   CircularProgress,
//   Container,
//   Grid,
//   InputAdornment,
//   TextField,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import { t } from "i18next";
// import React, { useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
// import DeveloperCard from "../components/DeveloperCard";
// import DeveloperFilters from "../components/DeveloperFilters";
// import Collapse from "@mui/material/Collapse";
// import CloseIcon from "@mui/icons-material/Close";
// import { useEffect } from "react";
// import API from "../config/axios";
// import { api_paths } from "../config/api.paths";

// // const developers = [
// //   {
// //     _id: "1",
// //     initials: "AC",
// //     name: "Alex Chen",
// //     role: "Senior Flutter Developer",
// //     experience: 6,
// //     location: "Singapore",
// //     time: "GMT+8",
// //     type: "Full-Time",
// //     area: "Cross-Platform",
// //     skills: ["Flutter", "Dart", "Firebase"],
// //     description:
// //       "Passionate mobile developer with 6+ years building cross-platform applications.",
// //   },
// //   {
// //     _id: "2",
// //     initials: "RP",
// //     name: "Raj Patel",
// //     role: "MERN Stack Developer",
// //     experience: 7,
// //     location: "London, UK",
// //     time: "GMT+8",
// //     type: "Part-Time",
// //     area: "Web",
// //     skills: ["React", "Node.js", "MongoDB", "Express"],
// //     description:
// //       "Full-stack JavaScript expert building scalable web applications.",
// //   },
// //   {
// //     _id: "3",
// //     initials: "MS",
// //     name: "Maria Santos",
// //     role: "Android Developer",
// //     experience: 5,
// //     location: "São Paulo, Brazil",
// //     time: "GMT-3",
// //     type: "Full-Time",
// //     area: "Mobile",
// //     skills: ["Kotlin", "Android SDK", "Jetpack Compose"],
// //     description:
// //       "Android specialist focused on modern development practices.",
// //   },
// //   {
// //     _id: "4",
// //     initials: "JW",
// //     name: "James Wilson",
// //     role: "React Developer",
// //     experience: 4,
// //     location: "Melbourne, Australia",
// //     time: "GMT+10",
// //     type: "Contract",
// //     area: "Full-Stack",
// //     skills: ["React", "TypeScript", "Next.js"],
// //     description:
// //       "Frontend developer passionate about clean and scalable UI.",
// //   },
// //   {
// //     _id: "5",
// //     initials: "YT",
// //     name: "Yuki Tanaka",
// //     role: "Full-Stack Developer",
// //     experience: 8,
// //     location: "Tokyo, Japan",
// //     time: "GMT+9",
// //     type: "Full-Time",
// //     area: "Full-Stack",
// //     skills: ["React", "Node.js", "PostgreSQL", "AWS"],
// //     description:
// //       "Versatile full-stack developer with DevOps expertise.",
// //   },
// //   {
// //     _id: "6",
// //     initials: "MJ",
// //     name: "Mihir Joshi",
// //     role: "Business Developer",
// //     experience: 3,
// //     location: "India",
// //     time: "UTC+5:30",
// //     type: "Full-Time",
// //     area: "Full-Stack",
// //     skills: ["Sales", "Strategy"],
// //     description:
// //       "Business developer specializing in user-centric solutions.",
// //   },
// // ];

// const Developers = () => {
//   const theme = useTheme();
//   const [filtersOpen, setFiltersOpen] = useState(false);
//   const [developers, setDevelopers] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");

//   // const [searchQuery, setSearchQuery] = useState("");
//   const [filters, setFilters] = useState({
//     technologies: [],
//     experience: [],
//     platform: [],
//   });
//   const [page, setPage] = useState(1);
//   const [totalResults, setTotalResults] = useState(0);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const LIMIT = 12;

//   const toggleFilters = () => {
//     setFiltersOpen((prev) => !prev);
//   };

//   const clearAllFilters = () => {
//     setFilters({
//       technologies: [],
//       experience: [],
//       platform: [],
//     });
//   };

//   const selectedCount =
//     filters.technologies.length +
//     filters.experience.length +
//     filters.platform.length;

//   const fetchDevelopers = async (pageNum = 1, append = false) => {
//     try {
//       if (pageNum === 1) setLoading(true);
//       else setLoadingMore(true);

//       const response = await API.get(api_paths.DEVELOPER.get, {
//         params: {
//           page: pageNum,
//           limit: LIMIT,
//           ...(debouncedSearch ? { search: debouncedSearch } : {}), // ✅ pass search
//         },
//       });

//       const data = response.data?.payload?.data;
//       const list = data?.employees || [];

//       setDevelopers((prev) => (append ? [...prev, ...list] : list));
//       setTotalResults(data?.totalResults || 0);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//       setLoadingMore(false);
//     }
//   };

//   const handleLoadMore = () => {
//     const nextPage = page + 1;
//     setPage(nextPage);
//     fetchDevelopers(nextPage, true);
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setDebouncedSearch(searchQuery);
//       setPage(1);
//     }, 400);
//     return () => clearTimeout(timer);
//   }, [searchQuery]);

//   useEffect(() => {
//     fetchDevelopers(1, false);
//   }, [debouncedSearch]);

//   const filteredDevelopers = developers.filter((developer) => {
//     const query = searchQuery.toLowerCase();
//     const matchesSearch =
//       developer.name.toLowerCase().includes(query) ||
//       developer.expertise?.name?.toLowerCase().includes(query) ||
//       developer.skills.some((skill) => skill.toLowerCase().includes(query));

//     // For now, only search is requested to be functional, but we keep existing filter logic if any was intended
//     // Note: The previous filters state didn't seem to be used in the map yet.
//     return matchesSearch;
//   });

//   return (
//     <Box sx={{ mt: 4, py: 6 }}>
//       <Box
//         sx={{
//           backgroundColor: theme.palette.background.developer,
//           py: 5,
//           borderBottom: "1px solid #e2e8f0",
//         }}
//       >
//         <Container maxWidth="xl">
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 700,
//               typography: "text4xl",
//               mb: 2,
//               color: "#0f172a",
//             }}
//           >
//             {t("pages.developers.headline")}
//           </Typography>

//           <Typography
//             sx={{
//               color: "#64748b",
//               maxWidth: "600px",
//               lineHeight: 1.6,
//             }}
//           >
//             {t("pages.developers.subheadline")}
//           </Typography>
//         </Container>
//       </Box>

//       <Box>
//         <Container maxWidth="xl" sx={{ mt: 4 }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               gap: 2,
//               flexWrap: "wrap",
//             }}
//           >
//             {/* Search Field */}
//             <TextField
//               placeholder="Search by name, role, or skill..."
//               variant="outlined"
//               size="medium"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               sx={{
//                 flex: 1,
//                 minWidth: { xs: "100%", sm: "320px" },
//                 maxWidth: "500px",
//                 backgroundColor: "#fff",
//                 borderRadius: 2,
//               }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon sx={{ color: "#94a3b8" }} />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {/* Filter Button */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 2,
//               }}
//             >
//               <Button
//                 variant="outlined"
//                 startIcon={<FilterAltOutlinedIcon />}
//                 onClick={toggleFilters}
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: "none",
//                   py: 1,
//                   px: 2,
//                   borderColor: filtersOpen
//                     ? theme.palette.success.main
//                     : "grey.200",
//                   color: filtersOpen ? theme.palette.success.main : "grey.900",
//                   position: "relative",
//                   "&:hover": {
//                     borderColor: theme.palette.success.main,
//                     backgroundColor: theme.palette.success.main,
//                     color: "#fff",
//                   },
//                 }}
//               >
//                 Filters
//                 {selectedCount > 0 && (
//                   <Box
//                     sx={{
//                       ml: 1,
//                       backgroundColor: theme.palette.success.main,
//                       color: "#fff",
//                       px: 1,
//                       borderRadius: "12px",
//                       fontSize: "12px",
//                     }}
//                   >
//                     {selectedCount}
//                   </Box>
//                 )}
//               </Button>

//               {selectedCount > 0 && (
//                 <Button
//                   onClick={clearAllFilters}
//                   sx={{
//                     textTransform: "none",
//                     color: "#64748b",
//                   }}
//                 >
//                   <CloseIcon />
//                   Clear All
//                 </Button>
//               )}
//             </Box>
//           </Box>

//           <Typography
//             variant="body2"
//             sx={{
//               color: "#64748b",
//               mt: 3,
//               fontWeight: 500,
//             }}
//           >
//             Showing {filteredDevelopers.length} of {developers.length}{" "}
//             developers
//           </Typography>

//           <Collapse in={filtersOpen}>
//             <DeveloperFilters filters={filters} setFilters={setFilters} />
//           </Collapse>

//           {/* <Box sx={{ mt: 4 }}>
//             <Grid container spacing={4}>
//               {filteredDevelopers.map((developer, index) => (
//                 <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
//                   <DeveloperCard developer={developer} />
//                 </Grid>
//               ))}
//             </Grid>
//           </Box> */}

//           <Box sx={{ mt: 4 }}>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <>
//                 <Grid container spacing={4}>
//                   {filteredDevelopers.map((developer, index) => (
//                     <Grid
//                       key={developer._id ?? index}
//                       size={{ xs: 12, sm: 6, md: 4 }}
//                     >
//                       <DeveloperCard developer={developer} />
//                     </Grid>
//                   ))}
//                 </Grid>
//               </>)}
//             {/* Load More */}
//             {developers.length < totalResults && (
//               <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
//                 <Button
//                   variant="outlined"
//                   onClick={handleLoadMore}
//                   disabled={loadingMore}
//                   sx={{
//                     backgroundImage: theme.palette.custom.buttonGradient,
//                     color: theme.palette.common.white,
//                     fontWeight: "500",
//                     textTransform: "none",
//                     borderRadius: "8px",
//                     py: 1.5,
//                     px: 4,
//                     boxShadow: "none",
//                     typography: "textSm",
//                   }}
//                 >
//                   {loadingMore ? "Loading..." : "Load More"}
//                 </Button>
//               </Box>
//             )}
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Developers;

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { t } from "i18next";
import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DeveloperCard from "../components/DeveloperCard";
import DeveloperFilters from "../components/DeveloperFilters";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import {
  buildUniqueTechnologies,
  normalizeSkillKey,
} from "../utils/skillNormalization";

const Developers = () => {
  const theme = useTheme();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [developers, setDevelopers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [filters, setFilters] = useState({
    technologies: [],
    experience: [],
    platform: [],
  });
  const [page, setPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const LIMIT = 12;

  // ─────────────────────────────────────────────────────────────
  // Build deduplicated technology chip list from all employees'
  // skills seen so far — ensures filters don't shrink when filtering
  // ─────────────────────────────────────────────────────────────
  const [allSeenDevelopers, setAllSeenDevelopers] = useState([]);

  useEffect(() => {
    if (developers.length > 0) {
      setAllSeenDevelopers((prev) => {
        const existingIds = new Set(prev.map((d) => d._id));
        const newDevs = developers.filter((d) => d._id && !existingIds.has(d._id));
        if (newDevs.length === 0) return prev;
        return [...prev, ...newDevs];
      });
    }
  }, [developers]);

  const availableTechnologies = useMemo(
    () => buildUniqueTechnologies(allSeenDevelopers),
    [allSeenDevelopers]
  );

  // ─────────────────────────────────────────────────────────────
  // Client-side filtering — Now simplified as filtering happens server-side
  // ─────────────────────────────────────────────────────────────
  const filteredDevelopers = useMemo(() => {
    return developers; // API already returns filtered results
  }, [developers]);

  // ─────────────────────────────────────────────────────────────
  // Fetch
  // ─────────────────────────────────────────────────────────────
  const fetchDevelopers = async (pageNum = 1, append = false) => {
    try {
      if (pageNum === 1) setLoading(true);
      else setLoadingMore(true);

      const response = await API.get(api_paths.DEVELOPER.get, {
        params: {
          isActive: true,
          page: pageNum,
          limit: LIMIT,
          ...(debouncedSearch ? { search: debouncedSearch } : {}),
          technologies: filters.technologies, // Array passed to axios
          experience: filters.experience,    // Array passed to axios
        },
      });

      const data = response.data?.payload?.data;
      const list = data?.employees || [];

      setDevelopers((prev) => (append ? [...prev, ...list] : list));
      setTotalResults(data?.totalResults || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchDevelopers(nextPage, true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPage(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setPage(1);
    fetchDevelopers(1, false);
  }, [debouncedSearch, filters]);

  const toggleFilters = () => setFiltersOpen((prev) => !prev);

  const clearAllFilters = () =>
    setFilters({ technologies: [], experience: [], platform: [] });

  const selectedCount =
    filters.technologies.length +
    filters.experience.length +
    filters.platform.length;

  return (
    <Box sx={{ mt: 4, py: 6 }}>
      {/* Header */}
      <Box
        sx={{
          backgroundColor: theme.palette.background.developer,
          py: 5,
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <Container maxWidth="xl">
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              typography: "text4xl",
              mb: 2,
              color: "#0f172a",
            }}
          >
            {t("pages.developers.headline")}
          </Typography>
          <Typography
            sx={{ color: "#64748b", maxWidth: "600px", lineHeight: 1.6 }}
          >
            {t("pages.developers.subheadline")}
          </Typography>
        </Container>
      </Box>

      <Box>
        <Container maxWidth="xl" sx={{ mt: 4 }}>
          {/* Search + Filter bar */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TextField
              placeholder="Search by name, expertise, or skills..."
              variant="outlined"
              size="medium"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                flex: 1,
                minWidth: { xs: "100%", sm: "320px" },
                maxWidth: "500px",
                backgroundColor: "#fff",
                borderRadius: 2,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#94a3b8" }} />
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                variant="outlined"
                startIcon={<FilterAltOutlinedIcon />}
                onClick={toggleFilters}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  py: 1,
                  px: 2,
                  borderColor: filtersOpen
                    ? theme.palette.success.main
                    : "grey.200",
                  color: filtersOpen
                    ? theme.palette.success.main
                    : "grey.900",
                  "&:hover": {
                    borderColor: theme.palette.success.main,
                    backgroundColor: theme.palette.success.main,
                    color: "#fff",
                  },
                }}
              >
                Filters
                {selectedCount > 0 && (
                  <Box
                    sx={{
                      ml: 1,
                      backgroundColor: theme.palette.success.main,
                      color: "#fff",
                      px: 1,
                      borderRadius: "12px",
                      fontSize: "12px",
                    }}
                  >
                    {selectedCount}
                  </Box>
                )}
              </Button>

              {selectedCount > 0 && (
                <Button
                  onClick={clearAllFilters}
                  sx={{ textTransform: "none", color: "#64748b" }}
                >
                  <CloseIcon />
                  Clear All
                </Button>
              )}
            </Box>
          </Box>

          {/* Result count */}
          <Typography
            variant="body2"
            sx={{ color: "#64748b", mt: 3, fontWeight: 500 }}
          >
            Showing {filteredDevelopers.length} of {totalResults} Engineer
          </Typography>

          {/* Filters panel */}
          <Collapse in={filtersOpen}>
            <DeveloperFilters
              filters={filters}
              setFilters={setFilters}
              technologies={availableTechnologies}
            />
          </Collapse>

          {/* Cards */}
          <Box sx={{ mt: 4 }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={4}>
                {filteredDevelopers.map((developer, index) => (
                  <Grid
                    key={developer._id ?? index}
                    size={{ xs: 12, sm: 6, md: 4 }}
                  >
                    <DeveloperCard developer={developer} />
                  </Grid>
                ))}
              </Grid>
            )}

            {/* Load More */}
            {developers.length < totalResults && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                <Button
                  variant="outlined"
                  onClick={handleLoadMore}
                  disabled={loadingMore}
                  sx={{
                    backgroundImage: theme.palette.custom.buttonGradient,
                    color: theme.palette.common.white,
                    fontWeight: "500",
                    textTransform: "none",
                    borderRadius: "8px",
                    py: 1.5,
                    px: 4,
                    boxShadow: "none",
                    typography: "textSm",
                  }}
                >
                  {loadingMore ? "Loading..." : "Load More"}
                </Button>
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Developers;